import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ListItem from '@material-ui/core/ListItem';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import clsx from 'clsx';

const AppDockItemBase = styled(ListItem)`
  && {
    justify-content: center;
    align-items: center;
  }
`;

const AppDockItemButton = styled(IconButton)`
  && {
    font-size: 1rem;
    width: 48px;
    height: 48px;

    &.active,
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }

    &.MuiIconButton-sizeSmall {
      width: 40px;
      height: 40px;
    }
  }
`;

const AppDockItem = ({
  icon,
  label,
  labelPlacement,
  enterDelay,
  leaveDelay,
  active,
  buttonRef,
  href,
  size,
  ...props
}) => (
  <AppDockItemBase {...props}>
    <Tooltip
      title={label}
      placement={labelPlacement}
      enterDelay={enterDelay}
      leaveDelay={leaveDelay}
    >
      <AppDockItemButton
        color="inherit"
        href={href}
        buttonRef={buttonRef}
        className={clsx({ active })}
        size={size}
      >
        {icon}
      </AppDockItemButton>
    </Tooltip>
  </AppDockItemBase>
);

AppDockItem.defaultProps = {
  active: false,
  dense: true,
  disableGutters: true,
  enterDelay: 300,
  labelPlacement: 'right',
  leaveDelay: 0,
  href: undefined,
  size: 'medium',
};

AppDockItem.propTypes = {
  active: PropTypes.bool,
  dense: PropTypes.bool,
  disableGutters: PropTypes.bool,
  enterDelay: PropTypes.number,
  icon: PropTypes.node.isRequired,
  labelPlacement: PropTypes.oneOf([
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start',
    'top',
  ]),
  leaveDelay: PropTypes.number,
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  ...ListItem.propTypes,
};

export default AppDockItem;
